import { render, staticRenderFns } from "./chatLogin.vue?vue&type=template&id=7a04b464&scoped=true&"
import script from "./chatLogin.vue?vue&type=script&lang=js&"
export * from "./chatLogin.vue?vue&type=script&lang=js&"
import style0 from "./chatLogin.vue?vue&type=style&index=0&id=7a04b464&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a04b464",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/home/chofn/components/SvgIcon.vue').default})
